import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

export type PickerPopoverShellProps = {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  bodyClassName?: string;
};

/** Shared shell for date/time picker popovers — one cohesive card across the app. */
export function PickerPopoverShell({
  children,
  footer,
  className,
  bodyClassName,
}: PickerPopoverShellProps) {
  return (
    <div className={cn('picker-popover', className)}>
      <div className={cn('picker-popover-body', bodyClassName)}>{children}</div>
      {footer ? <div className="picker-popover-footer">{footer}</div> : null}
    </div>
  );
}
